import React, { useEffect, useState } from "react"
import Icon from "../../../components/AppIcon"
import Button from "../../../components/ui/Button"

const THEME_KEY = "nesolearn-theme"
const DASHBOARD_ROOT_ID = "dashboard-theme-root"

const getInitialTheme = () => {
  if (typeof window === "undefined") return "light"
  const stored = window.localStorage.getItem(THEME_KEY)
  if (stored === "dark" || stored === "light") return stored
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ? "dark" : "light"
}

const ThemeToggle = () => {
  const [theme, setTheme] = useState(getInitialTheme)

      useEffect(() => {
    // Defensive cleanup: an earlier version of this toggle applied the
    // "dark" class to <html> directly. Since CSS custom properties
    // inherit down the whole page, a stray class left there would leak
    // dark colors into every page, including the public site. Strip it
    // unconditionally so only the scoped dashboard root ever carries it.
    document.documentElement.classList.remove("dark")

    const root = document.getElementById(DASHBOARD_ROOT_ID)
    if (!root) return
    if (theme === "dark") {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
    window.localStorage.setItem(THEME_KEY, theme)
  }, [theme])

  const toggleTheme = () => setTheme((prev) => (prev === "dark" ? "light" : "dark"))

  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-7 shrink-0"
      onClick={toggleTheme}
      title={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
    >
      <Icon name={theme === "dark" ? "Sun" : "Moon"} size={16} />
    </Button>
  )
}

export default ThemeToggle